import { createMuiTheme } from '@material-ui/core/styles'

export default createMuiTheme({
    palette: {
        primary: { main: '#3f51b5' },
        secondary: { main: '#f50057' }
    }
})